// extracted by mini-css-extract-plugin
module.exports = {"image-pane":"image-gallery_image-pane__v8WgF"};